import { collection, getDocs, limit, query } from "firebase/firestore";
import { runtimeDb as db } from "../../firestoreStudio/runtime/runtimeDb";

export async function smartSearch({
  searchTerm,
  collections,
  mode = "partial",
  searchIn = ["id", "field", "value"],
  perCollection = 30,
}) {
  const q = searchTerm.trim();
  if (!q || !collections?.length) return [];

  const term = mode === "exact" ? q : q.toLowerCase();
  const results = [];

  for (const col of collections) {
    try {
      const snap = await getDocs(query(collection(db, col), limit(perCollection)));
      snap.docs.forEach((d) => {
        const data = d.data() || {};
        if (searchIn.includes("id")) {
          const idMatch = mode === "exact" ? d.id === q : d.id.toLowerCase().includes(term);
          if (idMatch) {
            results.push({ collection: col, id: d.id, matchedField: "(document id)", matchedValue: d.id });
            return;
          }
        }
        for (const [field, val] of Object.entries(data)) {
          if (!searchIn.includes("field") && !searchIn.includes("value")) break;
          const str = JSON.stringify(val);
          const fieldHit = searchIn.includes("field") && (mode === "exact" ? field === q : field.toLowerCase().includes(term));
          const valHit = searchIn.includes("value") && (mode === "exact" ? str === q : str.toLowerCase().includes(term));
          if (fieldHit || valHit) {
            results.push({
              collection: col,
              id: d.id,
              matchedField: field,
              matchedValue: str.length > 120 ? `${str.slice(0, 120)}…` : str,
            });
          }
        }
      });
    } catch (e) {
      console.warn(`smartSearch skip ${col}`, e);
    }
  }

  return results;
}
